/* ============================================================
   WAIT FOR CART DRAWER TO EXIST
============================================================ */
function waitForCartDrawer(callback) {
  function check() {
    const drawer = document.querySelector('#sidebar-cart');
    if (drawer) callback(drawer);
    else setTimeout(check, 100);
  }
  check();
}

/* ============================================================
   CK | CART UPSELL — GLOBAL FUNCTIONS
============================================================ */
async function refreshCartUpsellVisibility(label = '') {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    if (!cart?.items) return;

    const cartVariantIds = cart.items.map(i => String(i.id));
    // console.log('[CK Upsell Cart] REFRESH:', label, cartVariantIds);

    const container = document.querySelector('.ck-upsell-cart-carousel');
    const cards = document.querySelectorAll('.ck-upsell-cart-carousel__card');

    let visibleCount = 0;



    cards.forEach(card => {
      const vid = card.dataset.variantId;
      if (!vid) return;

      const inCart = cartVariantIds.includes(String(vid));

      card.style.transition = 'opacity .25s ease';

      if (inCart) {
        card.classList.remove('ck-upsell-cart-carousel__card--visible');
        setTimeout(() => card.classList.add('ck-upsell-cart-carousel__card--hidden'), 250);
      } else {
        visibleCount++;
        card.classList.remove('ck-upsell-cart-carousel__card--hidden');
        setTimeout(() => card.classList.add('ck-upsell-cart-carousel__card--visible'), 25);
      }
    });


    if (container) {
      if (visibleCount > 0) {
        container.classList.remove('ck_cart_upsell_products--hidden');
        setTimeout(() => container.classList.add('ck_cart_upsell_products--visible'), 50);
        document.querySelector('.ck-upsell-cart-carousel').style.display = 'block';
        document.querySelector('.ck-upsell-cart-dekstop').style.display = 'block';
      } else {
        container.classList.remove('ck_cart_upsell_products--visible');
        setTimeout(() => container.classList.add('ck_cart_upsell_products--hidden'), 250);
        document.querySelector('.ck-upsell-cart-carousel').style.display = 'none';
        document.querySelector('.ck-upsell-cart-dekstop').style.display = 'none';
      }
    }

    const track = document.querySelector('.ck-upsell-cart-carousel__track');
    if (track) setTimeout(() => (track.scrollLeft = 0), 200);

  } catch (err) {
    console.error('[CK Upsell Cart] Visibility failed:', err);
  }
}

  function initCartUpsellDragging() {
  const tracks = document.querySelectorAll('.ck-upsell-cart-carousel__track');
  if (!tracks.length) return;

  tracks.forEach((track) => {
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;

    track.querySelectorAll('img, p').forEach((el) => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });

    track.addEventListener('pointerdown', (e) => {
      if (e.target.closest('.ck-upsell-carousel__toggle')) return;
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      const diff = e.clientX - startX;
      track.scrollLeft = scrollStart - diff;
    });

    function stopDragging() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', stopDragging);
    track.addEventListener('pointerleave', stopDragging);
    track.addEventListener('contextmenu', (e) => e.preventDefault());
  });
}


function initCartUpsellAddButtons() {
  document.querySelectorAll('.ck-upsell-cart-carousel__toggle').forEach(btn => {
    if (btn.dataset.ckBound === '1') return;
    btn.dataset.ckBound = '1';

    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      const card = btn.closest('.ck-upsell-cart-carousel__card');
      if (!card) return;

      const vid = card.dataset.variantId;
      if (!vid) return;

      card.classList.add('is-selected');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
          credentials: 'same-origin',
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const data = await res.json();

        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: data.items?.[0] || { id: Number(vid) },
              quantity: 1,
            },
          })
        );

      } catch (err) {
        console.error('[CK Upsell Cart] Failed to add:', err);
        card.classList.remove('is-selected');
      }
    });
  });
}

function initCartUpsell() {
//   console.log('[CK Upsell Cart] INIT');
  initCartUpsellDragging();
  initCartUpsellAddButtons();
  refreshCartUpsellVisibility('init');
}

/* ============================================================
   EVENT ATTACHMENTS
============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initCartUpsell();
});

document.addEventListener('product:added', () => {
  setTimeout(() => initCartUpsell(), 150);
});

document.addEventListener('click', (e) => {
  const isRemove = e.target.closest('[data-action="remove-item"]');
  const isUpdate = e.target.closest('[data-action="update-item-quantity"]');
  if (isRemove || isUpdate) {
    setTimeout(() => initCartUpsell(), 200);
  }
});

/* ============================================================
   WAIT FOR DRAWER → THEN ATTACH MUTATION OBSERVER
============================================================ */
waitForCartDrawer((drawer) => {
//   console.log('[CK Upsell Cart] Drawer detected — attaching observer');

  const observer = new MutationObserver(() => {
    setTimeout(() => initCartUpsell(), 50);
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true,
  });
});
